import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getIsDemo = createSelector(
  (state: RootState) => state.user,
  user => user.isDemo,
)
